import React from "react";
import ContentLoader from "react-content-loader";

const TeamListLoader = (props) => {

    return (
        <tr key={props.index}>
            <td colSpan="2" className="align-middle text-center">
                <ContentLoader
                    height={38}
                    width={'100%'}
                    speed={1}
                    backgroundColor={'#cfd8dc'}
                    foregroundColor={'#eceff1'}
                >
                    {/* Only SVG shapes */}
                    {/* <rect x="0" y="13" rx="3" ry="3" width="12" height="12" /> */}
                    <circle cx="15" cy="19" r="14" />
                    <rect x="40" y="13" rx="5" ry="5" width="100" height="12" />
                </ContentLoader>
            </td>
            <td className="align-middle ">
                <ContentLoader
                    height={38}
                    width={77.4}
                    speed={1}
                    backgroundColor={'#cfd8dc'}
                    foregroundColor={'#eceff1'}
                >
                    <rect x="30" y="13" rx="3" ry="3" width="16" height="12" />
                </ContentLoader>
            </td>
            <td className="align-middle" >
                <ContentLoader
                    height={38}
                    width={40.4}
                    speed={1}
                    backgroundColor={'#cfd8dc'}
                    foregroundColor={'#eceff1'}
                >
                    <rect x="12" y="9" rx="3" ry="3" width="20" height="20" />
                </ContentLoader>
            </td>
        </tr>
    )


}

export default TeamListLoader;
